import _ from "underscore";
import Backbone from "backbone";
import $ from "jquery";
import dateTimeService from "src/shared/date-time-service";

const CampaignSummaryModel = Backbone.Model.extend({
    idAttribute: "campaign_id",
    urlRoot: "api:///v2/campaign-summaries",
    hasDraft() {
        const publishedDateAsString = this.get("last_published_date");
        const updatedDateAsString = this.get("updated_date");

        const publishedDate = new Date(publishedDateAsString);
        const updatedDate = new Date(updatedDateAsString);

        if (
            !publishedDateAsString ||
            !dateTimeService.isDateValid(publishedDate)
        ) {
            return true;
        }

        if (!updatedDateAsString || !dateTimeService.isDateValid(updatedDate)) {
            return true;
        }
        return updatedDate > publishedDate;
    },

    getCampaignByVersion(campaignId, version) {
        const options = {
            type: "GET",
            url: `${this.urlRoot}/${campaignId}/version/${version}`,
        };

        return Backbone.sync.call(this, null, this, options);
    },
});

CampaignSummaryModel.create = function (campaignId) {
    return new CampaignSummaryModel({
        campaign_id: campaignId,
    });
};

export default CampaignSummaryModel;
